import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { enableProdMode, importProvidersFrom } from '@angular/core';
import { initFirebaseBackend } from './app/authUtils';
import { FakeBackendInterceptor } from './app/core/helpers/fake-backend';
import { buildCoreProviders } from './app/app.providers';

import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideFirestore, getFirestore } from '@angular/fire/firestore';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { provideFunctions, getFunctions } from '@angular/fire/functions';
import { provideStorage, getStorage } from '@angular/fire/storage';

if (environment.production) {
  enableProdMode();
}

if (environment.defaultauth === 'firebase') {
  initFirebaseBackend(environment.firebaseConfig);
} else {
  FakeBackendInterceptor;
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
      provideAuth(() => getAuth()),
      provideFirestore(() => getFirestore()),
      // Cloud Functions are deployed in europe-west3 (see functions/index.js).
      // Pinning the region here matches setGlobalOptions on the server side
      // so callable URLs resolve to the right host without an extra round trip.
      provideFunctions(() => getFunctions(undefined, 'europe-west3')),
      // Cloud Storage for event cover/profile images and other operator-
      // uploaded assets. Storage rules live in storage.rules.
      provideStorage(() => getStorage())
    ),
    ...buildCoreProviders()
  ]
}).catch((err) =>
  console.error('Error during bootstrapping the application:', err)
);
